import { CloudDownloadOutlined } from "@ant-design/icons";
import { Spin, Table } from "antd";
import { HELPER } from '../../../utils/helper';
import { useCallback, useEffect, useMemo, useState } from "react";
import { getAllCertifications } from "services/certifications.service";
import { Certification } from "types/certifications";
import dayjs from 'dayjs';
interface Props {
  itemsPerPage?: number;
}

export function TableCertifications(props: Props) {
  const { itemsPerPage = 10 } = props;

  const columnsData = useMemo(
    () => [
      {
        dataIndex: "fileName",
        title: "Nombre del archivo",
        key: "fileName",
      },
      {
        dataIndex: "uploadDate",
        title: "Fecha de carga",
        key: "uploadDate",
      },
      {
        dataIndex: "month",
        title: "Mes",
        key: "month",
      },
      {
        dataIndex: "year",
        title: "Año",
        key: "year",
      },
      {
        key: "url",
        title: "Archivo",
        render: (item) => (
          <a href={item?.url} target="_blank" >Descargar <CloudDownloadOutlined style={{fontSize:16, marginLeft:5}}/></a>
        ),
      },
    ],
    []
  );
  
  const [isLoading, setIsLoading] = useState(false);
  const [certifications, setCertifications] = useState<Certification[]>();

  const fetchAllCertifications = useCallback(async () => {
    try {
      setIsLoading(true);
      const resp = await getAllCertifications();
      setCertifications(resp.certifications);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
	}, []);
  
   useEffect(() => {
     fetchAllCertifications();
   }, [])
  
  return (
    <>
      {isLoading ? (
        <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
        <Spin />
        </div>
      ):(
        <Table
          bordered
          scroll={{ x: true }}
          dataSource={certifications?.map((item, index) => ({
            ...item,
            key: `${index}_${Date.now()}`,
            fileName: item?.short_file_name,
            uploadDate: dayjs(item?.upload_date).format('DD/MM/YYYY'),
            month: HELPER.getMonthNameByString(item?.month),
            year: item?.year,
            url: item?.file_url,
          }))
          //@ts-expect-error
          .sort((a, b) => dayjs(b.upload_date, 'DD/MM/YYYY') - dayjs(a.upload_date, 'DD/MM/YYYY'))
          }
          pagination={{
            defaultCurrent: 1,
              pageSize: 15,
              total: certifications?.length,
              hideOnSinglePage: true,
          }}
          columns={columnsData}
        />
      )}
    </>
  );
}
